import {combineReducers} from "redux";
import feedReducer from "./actions";

import dataReducer from "./features/data/dataSlice";

export const rootReducer = combineReducers({
  data: dataReducer,
  feed: feedReducer,
});
